/* eslint max-len: off */
// en
export default {
  choice_page: {
    options: {
      partner: 'AMEX Session',
      partner_2: 'Swire Session',
      partner_3: 'TX Session',
      public_audience: 'Public Session',
      vip: 'VIP Session',
    },
  },  
  form_entry_page: {
    title: "Exhibition Schedule",
    options: {
      salutations: {
        ms: 'Ms.',
        mrs: 'Mrs.',
        mr: 'Mr.',
      },
    },
    section1: {
      title: "1 — Select a Date"
    },
    section2: {
      title: "2 — Select a Time"
    },
    section3: {
      title: "Register",
      fields: {
        title: 'Salutation',
        first_name: 'First Name',
        last_name: 'Last Name',
        phone: 'Mobile Number',
        email: 'Email Address',
        age_group: 'Age Group',
        agree: "I have read and agreed to the <u>Terms Of Use</u> and <u>Privacy Policy</u>",
        agree_guests: 'Please ensure that your guest has given his/her consent to use his/her data. The data of your guest will be used by I.T for event registration only and will not be used for any other purpose.',
        rsvp_agree_terms: 'Subscribe to newsletter',
      },
      required: '* Required',
      buttons: {
        submit: "Submit"
      }
    },
    reservation_details: {
      title: "3 — Review"
    },
    modals: {
      terms_and_conditions: {
        body: `
        <h2>PRIVACY STATEMENT</h2>
        <br>
        <p>
          I.T Limited (“I.T”, “we” and “us”, as the case may be), its officers, management, and members of staff shall, at all times, respect the confidentiality of and endeavour to keep safe any and all personal data (“Personal Data”, as defined in the Personal Data (Privacy) Ordinance (Cap.486) of Hong Kong) (“Ordinance”)) collected from you and/or stored and/or transmitted by you to us. Please read the following to learn more about our Privacy Policy Statement (“Statement”) :
        </p>
        <br>
        <strong>Frequently Asked Questions</strong>
        <br><br>
        <strong>1. What this Statement Covers</strong>
        <p>
          This Statement covers our treatment of Personal Data that we collect when you are our member, when you subscribe with us or when you request us for our services. This Statement sets out how we use your Personal Data; what Personal Data we collect; how we ensure to protect your privacy; and your legal rights on your Personal Data.
        </p>
        <strong>2. Collection of Personal Data</strong>
        <p>
          2.1) For the purpose of carrying on I.T’s business, you may be requested to provide your Personal Data when you subscribe as our subscriber, when you visit our websites (including but not limited to hk.iteshop.com and hk.chocolate.com (collectively “ITeSHOP Websites”)), when you conduct a purchase transaction with us, when you join our VIP, membership, reward or loyalty program (“Membership”), when you conduct gift redemption / cash or discount voucher request, when you submit any comments or feedbacks to us and/or when you are required to verify your identity with us. 
        </p>
        <p>
          2.2) The Personal Data that you may be requested to provide with us includes but not limited to, inter alia, your name, contact phone no., email address, correspondence address, gender, date and month of birth, age group, payment details, purchase and order details, , delivery details, occupation, education and profession, and/or personal interests. 
        </p>
        <p>
          2.3) All Personal Data will be collected on a voluntary, open and fair basis. Certain Personal Data are required for specific services and if you fail to supply your Personal Data as requested from each specific service, we may not be able to provide you with our products or services. By providing your Personal Data to us, you acknowledge that such provision is fair and reasonable in the circumstances.
        </p>
        <strong>3. Purpose for Collection of Personal Data</strong>
        <p>
          I.T will collect your Personal Data for the following purposes :
        </p>
        <p>
          3.1)for the provision of products, services and/or facilities by the group of I.T (“I.T Group”) / its service providers (who are engaged by us to assist with providing you our services) to you. Such products and services shall be limited to fashion, footwear, bags, eyewear, accessories, watches, jewellery, stationery, lifestyle items, trendy items, cosmetics, personal care items, beauty items, high-technology devices, food and beverages;
        </p>
        <p>
          3.2)for carrying out your instructions or responding to your enquiry;
        </p>
        <p>
          3.3)for direct marketing purpose, including designing further products and services for you and marketing products or services in which I.T Group shall be involved but within the scope as mentioned in clause 3.1 above; 
        </p>
        <p>
          3.4)for payment purposes for products, services and/or facilities by I.T Group, including verification of your payment details with third parties (like banks, financial institutions, and other payment platforms);
        </p>
        <p>
          3.5)for use of the online services available at ITeSHOP Websites, or any of the websites of I.T Group and/or through other telecommunication channels;
        </p>
        <p>
          3.6)for identification and verification purposes in connection with any of the products, services and/or facilities by I.T Group that may be rendered to you;
        </p>
        <p>
          3.7)for managing customer relationship, including without limitation, any Membership programs run by I.T Group;
        </p>
        <p>
          3.8)for investigation of complaints, suspected suspicious transactions, and research for service improvement;
        </p>
        <p>
          3.9)for forming part of customer data base necessary for the operation by I.T Group; and/or
        </p>
        <p>
          3.10)for observing any legal, governmental or regulatory requirements of the Hong Kong Special Administrative Region (“Hong Kong”) or other relevant jurisdiction including any disclosure or notification requirements to which I.T or other class of data recipient, are subject.
        </p>
        <strong>4. Accuracy</strong>
        <p>
          I.T will take all practicable steps to ensure that the Personal Data so collected are accurate. However, your efforts to provide accurate Personal Data upon subscription of I.T Group’s services and thereafter to update I.T of any change of your Personal Data are always welcome.
        </p>
        <strong>5. Personal Data Sharing and Disclosure</strong>
        <p>
          5.1 Unless I.T hears from you to the contrary upon subscription or receives subsequent notice from you, I.T may, where such disclosure is necessary to satisfy the purpose for which the Personal Data was collected, provide such Personal Data to the following parties :
        </p>
        <p>
          5.1.1) employees and officers of I.T Group; 
        </p>
        <p>
          5.1 Unless I.T hears from you to the contrary upon subscription or receives subsequent notice from you, I.T may, where such disclosure is necessary to satisfy the purpose for which the Personal Data was collected, provide such Personal Data to the following parties :
        </p>
        <p>
          5.1.2) the brands traded, operated or owned by I.T Group but within the range of products and services as mentioned in clause 3.1 above;
        </p>
        <p>
          5.1.3) contractors / service providers of I.T Group (who are engaged by us to assist with providing you our services);
        </p>
        <p>
          5.1.4) other business associates, like operators of our Membership programs, or operators in providing customer care service or fulfilling customer requests;
        </p>
        <p>
          5.1.5) banks, financial institutions, credit reference agencies, credit, debit or charge card companies, and/or other payment platforms; and/or
        </p>
        <p>
          5.1.6) the court or regulatory body with subpoenas, court orders or for the purpose of legal process.
        </p>
        <p>
          5.2)The Personal Data you provide to us may also be sourced from or transferred to other jurisdictions outside Hong Kong for any of the aforesaid purposes.
        </p>
        <strong>6. Access and Correction</strong>
        <p>
          6.1)You have the right to know :
        </p>
        <p>
          6.1.1)the privacy policy of I.T;
        </p>
        <p>
          6.1.2)whether I.T holds any of your Personal Data; and
        </p>
        <p>
          6.1.3)the kind of Personal Data being held by I.T.
        </p>
        <p>
          6.2)You have full control and ability to correct or edit your Personal Data at any time, including whether you want us to contact you about direct marketing purpose, promotional offers and new products and services, and/or deletion of your subscriber or Membership account.
        </p>
        <p>
          6.3)You may request your right of access or right of correction by logging in at https://member-hk.iteshop.com. Alternatively, you can write to us via e-mail to service.hk@iteshop.com or via mail at 20/F, Tower A, Southmark, 11 Yip Hing Street, Wong Chuk Hang, Hong Kong (attention to Customer Relations Department) or via fax to (852) 2237 6674. I.T will, upon satisfying itself of the authenticity and validity of the access or correction request, make every endeavor to comply with and respond to the request within the period set by the statutory requirement.
        </p>
        <p>
          6.4)Pursuant to the Ordinance, I.T is entitled to charge a reasonable fee for our processing of any data access request.
        </p>
        <strong>7. Security</strong>
        <p>
          Data security is our top priority. We strive to ensure that your Personal Data will be protected against unauthorized or accidental access, processing or erasure. We maintain this commitment to data security by implementing appropriate physical, electronic and managerial measures to safeguard and secure your Personal Data. Encryption technology, such as SSL, may be employed for the transmission of Personal Data collected online. Also, our web servers are protected by data security measures and our systems are monitored to prevent any unauthorized access. However, you are also invited to protect against unauthorised access to your Membership or log-in account, password, payment and credit card details, and delivery details.
        </p>
        <strong>8. Retention of Personal Data</strong>
        <p>
          Your Personal Data will only be retained for as long as is necessary to fulfill the original purpose for which it was collected, unless contrary to any applicable statutory requirement.
        </p>
        <strong>9. Amendment to this Statement</strong>
        <p>
          9.1) We may amend this Statement from time to time. If we make any substantial amendments in the way we use your Personal Data, we will notify you by posting a prominent announcement on the ITeSHOP Websites. You agree that such posting will constitute sufficient and adequate notice to you of the amendments.
        </p>
        <p>
          9.2) You agree that your continued use of our products or services after such amendment will constitute your acceptance of and agreement to be bound by the modified Statement.
        </p>
        <strong>10. Direct Marketing</strong>
        <p>
          I.T may contact you from time to time with a view to providing the latest information on our products and services / Membership program. If you do not wish to receive these updates, please login at https://member-hk.iteshop.com to unsubscribe. Alternatively, you may click the unsubscribe link as shown in our electronic promotional materials; or can write to us via e-mail to service.hk@iteshop.com or via mail at 20/F, Tower A, Southmark, 11 Yip Hing Street, Wong Chuk Hang, Hong Kong (attention to Customer Relations Department) or via fax to (852) 2237 6674. In accordance with the statutory requirements, I.T will honour your request not to use your Personal Data for the purposes of direct marketing. Unless otherwise instructed as per the above, I.T may use any of your Personal Data collected in the normal course of our business for direct marketing purposes.
        </p>
        <strong>11. Links to third parties’ websites</strong>
        <p>
          ITeSHOP Websites may contain links to third parties’ websites that are operated under different privacy policy and are totally independent from us. I.T is not responsible for the contents on such websites or how information is collected. You should read and understand the privacy policy of any such third parties’ websites before submitting any Personal Data to them.
        </p>
        <strong>12. Contact Us</strong>
        <p>
          If you have any questions regarding this Statement, please email us at service.hk@iteshop.com.
        </p>
        <strong>13. General</strong>
        <p>
          13.1) By signing in the Membership form, or logging in as our subscriber, or registering as our member, or continuing your browsing of ITeSHOP Websites, you agree to comply with the Statement set out above.
        </p>
        <p>
          13.2) In case of discrepancies between the English and Chinese versions, the English version shall apply and prevail.
        </p>
        <p>
          13.3) This Statement shall be governed by and construed in accordance with the laws of Hong Kong. Where I.T's operations are subject to privacy legislation other than that of Hong Kong, then this Statement shall be applied so far as practicable and consistent with such local legislation.
        </p>
        <br>
        <p>
          Effective on : 18th January 2018
        </p>
        `,
        buttons: {
          close: "Close"
        }
      },
      accept_terms: {
        body: ``,
        buttons: {
          accept: 'Accept',
        }
      }
    }
  },
  home_page: {
    title: "Home",
    section_title: "Register Now",
    message: "RSVP now for the chance to win<br />merchandise valued up to HK$1,000.",
    button: "Make a reservation"
  },
  login_page: {
    title: 'Login or Register with mobile no.',
    message: 'RSVP now for the chance to win<br />merchandise valued up to HK$1,000.',
    sms_code_message: 'Enter SMS verification code sent to {{mobile_number}}',
    did_not_receive_code: 'Didn\'t receive a verification code?',
    fields: {
      mobile_number: 'Mobile Number',
      sms_code: 'SMS Code',
    },
    buttons: {
      get_verification_code: 'Get Verification Code',
      resend_code: 'Resend Code',
      submit: 'Submit',
    },
  },
  complete_page: {
    main_title: "Confirmed",
    title: {
      one: '',
      other: '',
      zero: 'Thank you for your interest. See you soon!',      
    },
    message: "Your exhibition reservation has been confirmed.<br />Please keep an eye out for SMS updates.",
    alt_qrcode_message: "Present QR code to check in",
    reservation: {
      title: 'Your Reservation',
      venue_address: "Level L1, Pacific Place",
      labels: {
        name: "Name",
        mobile: "Mobile",
        email: "Email",
        date: "Reservation Time: {{type}}",
        venue: "Venue",
        expired: "Expired",
        used: "Attended"
      }
    },
    buttons: {
      change_timeslot: "Change Reservation"
    },
    did_not_receive_sms: {
      title: "Didn't receive a SMS?",
      message:
        "If you are experiencing any issues with your RSVP, please contact I.T customer service at 3144 0111.",
      button: "Resend SMS"
    },
    modals: {
      // resend_sms: {
      //   title: '感谢你的登记',
      //   body: '确认短讯已发送至你登记的电话号码。',
      //   button: '好',
      // },
      change_reservation: {
        title: 'Change Reservation',
        body: 'Are you sure you want to change your reservation?',
        buttons: {
          yes: 'Yes',
          no: 'No',
        },
      },
    }
  },
  no_more_sessions_page: {
    title: 'Thank you!',
    body: `
      <br />
      Reservation Complete
    `,
  },
  no_more_timeslots_page: {
    title: 'Thank you',
    body: `
      <br />
      Sorry, the Event is fully booked.<br />
      <br />
      Thank you for participating in the event.
    `,
  },  
  event_closed_page: {
    title: 'Thank you!',
    body: `
      <br />
      Reservation Complete
    `, // TODO: i18n
  },
  rsvp_closed_page: {
    title: 'Thank you!',
    body: `
      <br />
      Reservation Complete
    `,
  },
  it_rsvp_30th_anniv: {
    event_details: {
      title: "I.T 30th Anniversary Exhibition",
      description_1: "In celebrating I.T's 30th birthday, we invite you to join us in visualising the future of retail at a truly unprecedented digital exhibition.",
      description_2: "The exhibition embraces the see-now-buy-now trend, introducing an innovative digital shopping experience. Guests will preview I.T’s 30th anniversary online exclusive products and fully immerse in the harmonic combination of fashion and technology.",
      description_3: "Register today for priority access.",
      address: "Level L1, Pacific Place",
      date: "26 - 28 October, 2018"
    },
    early_access: {
      title: "Product Info",
      description:
        "Once registered for the event, you’ll get access to a sneak peak of our upcoming anniversary exclusive collection."
    },
    footer: {
      title: "EARLY ACCESS",
      description:
        "Once registered for the event, you’ll get access to a sneak peak of our upcoming anniversary exclusive collection.",
      link_data: {
        email: {
          label: "itrsvp@ithk.com",
          url: "mailto:itrsvp@ithk.com"
        },
        phone: {
          label: `
            +852 3144 0111<br />
            (19-24 Oct 10:00 - 18:00;<br />
            25-28 Oct 10:00 - 21:30)
          `,
          url: "tel:+85231440111"
        },        
        privacy: {
          label: "Privacy Policy",
          url: "https://hk.iteshop.com/b_it/help/privacy-policy"
        },
        legal: {
          label: "Terms & Conditions",
          url: "https://hk.iteshop.com/b_it/help/terms-of-use"
        }
      }
    },
    language_switcher: {
      title: 'Select Language',
      button: {
        en_label: 'English',
        cn_label: '中文'
      }
    },
    app_header: {
      title: 'I.T 30th Anniversary Exhibition'
    }
  },
  walkin_complete_page: {
    title: 'Thank you',
    body: `
      <br />
      Thank you for participating in the event.
    `,
  },  
};



// WEBPACK FOOTER //
// ./src/locales/en.js